import { Box, Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import WSButton from "../Components/Button/WSButton";
import { WSIcons } from "../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";

export const NotFound = ({ onRetry }: { onRetry?: () => void }) => {
  const navigate = useNavigate();

  return (
    <>
      <Helmet>
        <title>Not Found | Willsoar Technologies</title>
        <meta
          name="description"
          content="Oops! The page you’re looking for doesn’t exist. Go back to the dashboard or retry."
        />
      </Helmet>

      <Box
        sx={{
          backgroundColor: "rgba(26,32,44,1)", // dark blue-gray
          height: "100vh",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 2,
          color: "#fff"
        }}
      >
        <WSIcons.ErrorOutlineIcon color="error" sx={{ fontSize: 100, mb: 2 }} />
        
        <Typography variant="h4" fontWeight="bold" gutterBottom>
          404 - Page Not Found
        </Typography>

        <Typography variant="body1" maxWidth={500}>
          Sorry, the page or data you’re trying to access doesn’t exist or may have been removed.
        </Typography>

        <Box display="flex" gap={2} mt={4} flexWrap="wrap" justifyContent="center">
          {onRetry && (
            <WSButton
              id="retry"
              variant="contained"
              color="primary"
              onClick={onRetry}
              label="Retry"
            />
          )}
          <WSButton
            id="go-home"
            variant="outlined"
            color="error"
            onClick={() => navigate("/")}
            label="Go to Home"
          />
        </Box>
      </Box>
    </>
  );
};
